import { UserRoleEnum } from "@nlc/shared-types";
import { useState } from "react";

import type { DesignerFilterType } from "@/features/requests/components/DesignerDropdownFilter";
import type { TeamLeadFilterType } from "@/features/requests/components/TeamLeadDropdownFilter";

import { SearchField, SearchInput } from "@/components/search-field";
import { DesignerDropdownFilter } from "@/features/requests/components/DesignerDropdownFilter";
import { AssignedToMeTab as DesignerAssignedToMeTab } from "@/features/requests/components/tabs/designer";
import { AssignedToMeTab as TeamLeadAssignedToMeTab } from "@/features/requests/components/tabs/teamlead";
import { TeamLeadDropdownFilter } from "@/features/requests/components/TeamLeadDropdownFilter";
import { useDebounce } from "@/hooks/useDebounce";

interface AssignedToMeTabProps {
  user: {
    id: number;
    roleId: UserRoleEnum;
  };
}

function DesignerView({ userId }: { userId: string }) {
  const [requestsSearch, setRequestsSearch] = useState("");
  const [requestsFilter, setRequestsFilter] =
    useState<DesignerFilterType>("open");
  const debouncedRequestsSearch = useDebounce(requestsSearch, 300);

  return (
    <div>
      <div className="flex items-center justify-between gap-2xl py-lg pr-2xl">
        <DesignerDropdownFilter
          onFilterChange={setRequestsFilter}
          selectedFilter={requestsFilter}
        />
        <SearchField aria-label="Search requests" className="flex-1">
          <SearchInput
            onChange={(e) => setRequestsSearch(e.target.value)}
            onClear={() => setRequestsSearch("")}
            placeholder="Search..."
            value={requestsSearch}
          />
        </SearchField>
      </div>
      <DesignerAssignedToMeTab
        searchValue={debouncedRequestsSearch}
        selectedFilter={requestsFilter}
        userId={userId}
      />
    </div>
  );
}

function TeamLeadView({ userId }: { userId: string }) {
  const [requestsSearch, setRequestsSearch] = useState("");
  const [requestsFilter, setRequestsFilter] =
    useState<TeamLeadFilterType>("open");
  const debouncedRequestsSearch = useDebounce(requestsSearch, 300);

  return (
    <div>
      <div className="flex items-center justify-between gap-2xl py-lg pr-2xl">
        <TeamLeadDropdownFilter
          onFilterChange={setRequestsFilter}
          selectedFilter={requestsFilter}
        />
        <SearchField aria-label="Search requests" className="flex-1">
          <SearchInput
            onChange={(e) => setRequestsSearch(e.target.value)}
            onClear={() => setRequestsSearch("")}
            placeholder="Search..."
            value={requestsSearch}
          />
        </SearchField>
      </div>
      <TeamLeadAssignedToMeTab
        searchValue={debouncedRequestsSearch}
        selectedFilter={requestsFilter}
        userId={userId}
      />
    </div>
  );
}

export function AssignedToMeTab({ user }: AssignedToMeTabProps) {
  if (user.roleId === UserRoleEnum.TeamLeader) {
    return <TeamLeadView userId={String(user.id)} />;
  }

  return <DesignerView userId={String(user.id)} />;
}
